export const MainHeaderContent = {
    en: {
        DesktopMenu: ["Conversations", "Categories", "Directory"],
        PhoneMenu: ["Learn by Conversations", "Expressions by Categories", "Vocabulary Index"]
    },
    es: {
        DesktopMenu: ["Conversaciones", "Categorías", "Directorio"],
        PhoneMenu: ["Aprende por Conversaciones", "Expresiones por Categorías", "Índice de vocabulario"]
    }
}